export default __webpack_public_path__ + "static/media/streaming.b33bde41.png";